/**
 * Created by Carry on June/11/18.
 */
export default {
  // 可播放视频组件的id
  MAIN_VIEW: "MAIN_VIEW", // 单个预览视频view
  TRIM_VIEW: "TRIM_VIEW", // 裁剪视频的view
  CLIP_VIDEO_VIEW: "CLIP_VIDEO_VIEW", // 切割的view
  PREVIEW_VIEW: "PREVIEW_VIEW", // 全局预览的view
  PREVIEW_VIEW_WITH_INTRO: "PREVIEW_VIEW_WITH_INTRO", // 输出时的预览
  MUSIC_TEXT_TRIM_VIEW: "MUSIC_TEXT_TRIM_VIEW", // 音乐剪辑与文字剪辑View

  VIEW_TYPE_PHOTO: "VIEW_TYPE_PHOTO", // 图片类型View
  VIEW_TYPE_VIDEO: "VIEW_TYPE_VIDEO", // 视频类型View
  VIEW_TYPE_MEDIA: "VIEW_TYPE_MEDIA", // 媒体类型View
  VIEW_TYPE_COLOR: "VIEW_TYPE_COLOR", // 纯背景类型View

  FIT: "FIT", // 用于zoomScale

  // 选中的对象类型
  SELECTED_TYPE_COLOR: "SELECTED_TYPE_COLOR",
  SELECTED_TYPE_PHOTO: "SELECTED_TYPE_PHOTO",
  SELECTED_TYPE_VIDEO: "SELECTED_TYPE_VIDEO",
  SELECTED_TYPE_TEXT: "SELECTED_TYPE_TEXT",
  SELECTED_TYPE_LOGO: "SELECTED_TYPE_LOGO",
  SELECTED_TYPE_DECORATION_OVERLAY: "SELECTED_TYPE_DECORATION_OVERLAY",

  SELECTED_TYPE_OVERLAY: "SELECTED_TYPE_OVERLAY", // 选中overlay整体
  SELECTED_TYPE_OVERLAY_TEXT: "SELECT_TYPE_OVERLAY_TEXT", // 选中overlay中的文字
  SELECTED_TYPE_OVERLAY_IMAGE: "SELECT_TYPE_OVERLAY_IMAGE", // 选中overlay中的图片

  SELECTED_TYPE_WIDGET: "SELECTED_TYPE_WIDGET", // 选中小组件
  SELECTED_TYPE_STATIC_SVG: "SELECTED_TYPE_STATIC_SVG", // 选中svg

	// stock type
	STOCK_VIDEO_VIDEO: "STOCK_VIDEO_VIDEO",
	STOCK_VIDEO_PHOTO: "STOCK_VIDEO_PHOTO",
	STOCK_VIDEO_MUSIC: "STOCK_VIDEO_MUSIC",

  // ratio
  RATIO_LANDSCAPE: "RATIO_LANDSCAPE",
  RATIO_VERTICAL: "RATIO_VERTICAL",
  RATIO_SQUARE: "RATIO_SQUARE",
  RATIO_CINEMATIC: "RATIO_CINEMATIC",
  RATIO_SOCIAL: "RATIO_SOCIAL",

  // tooltip
  TOOLTIP_TOP: "TOOLTIP_TOP",
  TOOLTIP_BOTTOM: "TOOLTIP_BOTTOM",
  TOOLTIP_LEFT: "TOOLTIP_LEFT",
  TOOLTIP_RIGHT: "TOOLTIP_RIGHT",

  // submit
  SUBMIT_BUTTON_NORMAL: "SUBMIT_BUTTON_NORMAL",
  SUBMIT_BUTTON_WARNING: "SUBMIT_BUTTON_WARNING",

  // playState
  PLAY: "PLAY",
  PAUSE: "PAUSE",
  STOP: "STOP",

  ZOOM_IN: "ZOOM_IN",
  ZOOM_OUT: "ZOOM_OUT",

  // apply to all type
  APPLY_ALL_BG_COLOR: "APPLY_ALL_BG_COLOR",
  APPLY_ALL_FONT_COLOR: "APPLY_ALL_FONT_COLOR",
  APPLY_ALL_FONT_FAMILY: "APPLY_ALL_FONT_FAMILY",
  APPLY_ALL_LOGO_COLOR: "APPLY_ALL_LOGO_COLOR",
  APPLY_ALL_LOGO_FAMILY: "APPLY_ALL_LOGO_FAMILY",
  APPLY_ALL_ZOOM: "APPLY_ALL_ZOOM",
  APPLY_ALL_VOLUME: "APPLY_ALL_VOLUME",
  APPLY_ALL_OVERLAY_FONT_COLOR: "APPLY_ALL_OVERLAY_FONT_COLOR",
  APPLY_ALL_OVERLAY_FONT_FAMILY: "APPLY_ALL_OVERLAY_FONT_FAMILY",
  APPLY_ALL_FILTER: "APPLY_ALL_FILTER",
  APPLY_ALL_ADJUST_FILTER: "APPLY_ALL_ADJUST_FILTER",

  TOOL_PANEL_ELEMENT: "TOOL_PANEL_ELEMENT",
  TOOL_PANEL_TEXT: "TOOL_PANEL_TEXT",
  TOOL_PANEL_BACKGROUND: "TOOL_PANEL_BACKGROUND",
  TOOL_PANEL_WATERMARK: "TOOL_PANEL_WATERMARK",
  TOOL_PANEL_MORE: "TOOL_PANEL_MORE",
  TOOL_PANEL_OVERLAY: "TOOL_PANEL_OVERLAY",
  TOOL_PANEL_WIDGET: "TOOL_PANEL_WIDGET",
  TOOL_PANEL_TEXT_AND_LOGO: "TOOL_PANEL_TEXT_AND_LOGO",
  TOOL_PANEL_MUSIC: "TOOL_PANEL_MUSIC",
  TOOL_PANEL_SETTING: "TOOL_PANEL_SETTING",
  TOOL_PANEL_ADJUST: "TOOL_PANEL_ADJUST",

  TOOL_PANEL_SVG_ANIMATION: "TOOL_PANEL_SVG_ANIMATION",
  TOOL_PANEL_FILTER: "TOOL_PANEL_FILTER",
  TOOL_SUB_PANEL_TEXT: "TOOL_SUB_PANEL_TEXT",
  TOOL_SUB_PANEL_LOGO: "TOOL_SUB_PANEL_LOGO",


  SOLID_COLOR: "SOLID_COLOR",
  DOUBLE_COLOR: "DOUBLE_COLOR",

  ZOOM_CHANGE_START: "ZOOM_CHANGE_START",
  ZOOM_CHANGE_ING: "ZOOM_CHANGE_ING",
  ZOOM_CHANGE_NORMAL: "ZOOM_CHANGE_NORMAL",
  ZOOM_CHANGE_END: "ZOOM_CHANGE_END",

  SAVE_PROJECT: "SAVE_PROJECT",
  LOAD_PROJECT: "LOAD_PROJECT",

  CONTROLLER_EVENT_EDIT_VIEW: "CONTROLLER_EVENT_EDIT_VIEW",
  CONTROLLER_EVENT_VIDEO_TRIM_VIEW: "CONTROLLER_EVENT_VIDEO_TRIM_VIEW",
  CONTROLLER_EVENT_PREVIEW_VIEW: "CONTROLLER_EVENT_PREVIEW_VIEW",
  CONTROLLER_EVENT_PREVIEW_INTRO_VIEW: "CONTROLLER_EVENT_PREVIEW_INTRO_VIEW",
  CONTROLLER_EVENT_AUDIO_TRIM_VIEW: "CONTROLLER_EVENT_AUDIO_TRIM_VIEW",
  CONTROLLER_EVENT_AUDIO_TEXT_TRIM_VIEW: "CONTROLLER_EVENT_AUDIO_TEXT_TRIM_VIEW",
  CONTROLLER_EVENT_WEB_VIDEO_VIEW: "CONTROLLER_EVENT_WEB_VIDEO_VIEW",

  DEFAULT_FONT_FAMILY: "DEFAULT_FONT_FAMILY",
  DEFAULT_FONT_BOLD: "DEFAULT_FONT_BOLD",
  DEFAULT_FONT_ITALIC: "DEFAULT_FONT_ITALIC",
  DEFAULT_FONT_MAIN_COLOR: "DEFAULT_FONT_MAIN_COLOR",
  DEFAULT_FONT_SUB_COLOR: "DEFAULT_FONT_SUB_COLOR",

  MODAL_COMMON_BTN_SUBMIT: "MODAL_COMMON_BTN_SUBMIT",
  MODAL_COMMON_BTN_WARNING: "MODAL_COMMON_BTN_WARNING",
  MODAL_COMMON_BTN_NORMAL: "MODAL_COMMON_BTN_NORMAL",
  MODAL_COMMON_BTN_GREEN: "MODAL_COMMON_BTN_GREEN",

  POSITION_LEFT: "POSITION_LEFT",
  POSITION_CENTER_VERTICAL: "POSITION_CENTER_VERTICAL",
  POSITION_RIGHT: "POSITION_RIGHT",
  POSITION_TOP: "POSITION_TOP",
  POSITION_CENTER_HORIZONTAL: "POSITION_CENTER_HORIZONTAL",
  POSITION_BOTTOM: "POSITION_BOTTOM",

  SORT_TYPE_RELEVANT: "SORT_TYPE_RELEVANT",
  SORT_TYPE_DOWNLOADED: "SORT_TYPE_DOWNLOADED",
  SORT_TYPE_RATED: "SORT_TYPE_RATED",
  SORT_TYPE_RESENT: "SORT_TYPE_RESENT",
  SORT_TYPE_TRENDING: "SORT_TYPE_TRENDING",
  SORT_TYPE_UNDISCOVERED: "SORT_TYPE_UNDISCOVERED",

  FETCH_LOADING: "FETCH_LOADING",
  FETCH_SUCCESS: "FETCH_SUCCESS",
  FETCH_ERROR: "FETCH_ERROR",

  ADD_MEDIA_TYPE_REPLACE: "ADD_MEDIA_TYPE_REPLACE",
  ADD_MEDIA_TYPE_NEW: "ADD_MEDIA_TYPE_NEW",

  EXPORT_FOR_WASM: "EXPORT_FOR_WASM",
  EXPORT_FOR_START: "EXPORT_FOR_START",
  EXPORT_FOR_END: "EXPORT_FOR_END",

  DRAG_FILE_MODE_CANVAS: "DRAG_FILE_MODE_CANVAS",
  DRAG_FILE_MODE_OTHER: "DRAG_FILE_MODE_OTHER",
  DRAG_ELEMENT: "DRAG_ELEMENT",
  DRAG_SELECTED_TEXT: "DRAG_SELECTED_TEXT",

  GRAPH_TEXT_ANIMATION: "textAnimation",
  GRAPH_OVERLAY: "overlay",
  GRAPH_WIDGET: "widget",
  GRAPH_DECORATION_OVERLAY: "decorationOverlay",
  GRAPH_STATIC_SVG: "staticSVG",
  GRAPH_OVERLAY_TEXT: "overlayText",
  GRAPH_OVERLAY_SHAPE: "overlayShape",
  GRAPH_STATIC_LOGO: "staticLogo",
  GRAPH_DYNAMIC_LOGO: "dynamicLogo",

  LEFT_TOP: "left-top",
  TOP: "center-top",
  RIGHT_TOP: "right-top",
  RIGHT: "right-center",
  RIGHT_BOTTOM: "right-bottom",
  BOTTOM: "center-bottom",
  LEFT_BOTTOM: "left-bottom",
  LEFT: "left-center",
  CENTER: "center",

  SHOW_CONFIRM_RE_RECORDING: "SHOW_CONFIRM_RE_RECORDING",
  SHOW_RECORDING_VIEW: "SHOW_RECORDING_VIEW",
  HIDE_RECORDING_VIEW: "HIDE_RECORDING_VIEW",
  START_COUNT_DOWN: "START_COUNT_DOWN",
  END_COUNT_DOWN: "END_COUNT_DOWN",
  CLOSE_COUNT_DOWN: "CLOSE_COUNT_DOWN",
  CHANGE_WEB_CAM_RECORDING_STATE: "CHANGE_WEB_CAM_RECORDING_STATE",
  CHANGE_RECORDING_CONFIG: "CHANGE_RECORDING_CONFIG",
  CHANGE_CAMERA_BUTTON_STATE: "CHANGE_CAMERA_BUTTON_STATE",
  START_RECORDING_TIMING: "START_RECORDING_TIMING",
  END_RECORDING_TIMING: "END_RECORDING_TIMING",
  START_RECORDING_SCREEN_TIMING: "START_RECORDING_SCREEN_TIMING",
  END_RECORDING_SCREEN_TIMING: "END_RECORDING_SCREEN_TIMING",
  CHANGE_SCREEN_RECORDING_SATTE: "CHANGE_SCREEN_RECORDING_SATTE",
  GET_SCREEN_SHOT_IMAGE: "GET_SCREEN_SHOT_IMAGE",
  GET_VIDEO_TAPE_SRC: "GET_VIDEO_TAPE_SRC",
  CHANGE_TRIM_RECORDING_VIDEO_TYPE: "CHANGE_TRIM_RECORDING_VIDEO_TYPE",
  DO_SCREEN_SHOT: "DO_SCREEN_SHOT",
  SET_CAMERA_LIST: "SET_CAMERA_LIST",
  SET_MICROPHONE_LIST: "SET_MICROPHONE_LIST",
  RECORDING_VIDEO_OR_IMAGE_STORY_CHANGE: "RECORDING_VIDEO_OR_IMAGE_STORY_CHANGE",
  SET_RECORDING_STORY_INDEX: "SET_RECORDING_STORY_INDEX",
  SET_VIDEO_DURATION_TIME: "SET_VIDEO_DURATION_TIME",
  SET_IS_OPEN_RECORDING_TRIM_VIDEO_MODAL: "SET_IS_OPEN_RECORDING_TRIM_VIDEO_MODAL",

  // 左侧资源面板类型
  RESOURCES_MEDIA: 'RESOURCES_MEDIA',
  RESOURCES_TEXT: 'RESOURCES_TEXT',
  RESOURCES_BACKGROUND: 'RESOURCES_BACKGROUND',
  RESOURCES_ELEMENT: 'RESOURCES_ELEMENT',
  RESOURCES_TRANSITION: 'RESOURCES_TRANSITION',
  RESOURCES_ANIMATION_INTRO: 'RESOURCES_ANIMATION_INTRO',
  RESOURCES_ANIMATION_OUTRO: 'RESOURCES_ANIMATION_OUTRO',
  RESOURCES_FILTER: 'RESOURCES_FILTER',
  RESOURCES_ADJUST: 'RESOURCES_ADJUST',
  RESOURCES_OVERLAY: 'RESOURCES_OVERLAY',
	RESOURCES_PHOTO_TRANSITION: 'RESOURCES_PHOTO_TRANSITION',
	RESOURCES_WATER_MARK: 'RESOURCES_WATER_MARK',
	RESOURCES_MORE: 'RESOURCES_MORE',

  SVG_LOCAL: 'LOCAL',
  SVG_WEB: 'WEB',

  // 媒体状态
  MEDIA_STATUS_SUCCESS: 'SUCCESS',
  MEDIA_STATUS_LOADING: 'LOADING',
  MEDIA_STATUS_DOWNLOADING: 'DOWNLOADING',
  MEDIA_STATUS_LINK: 'LINK',
  MEDIA_STATUS_ERROR: 'ERROR',
	MEDIA_STATUS_RETRY: 'RETRY',

  INTRO: 'INTRO',
  OUTRO: 'OUTRO',

  SET_FILTER_TYPE: 'SET_FILTER_TYPE',
  SET_FILTER_ACTIVE: 'SET_FILTER_ACTIVE',
  SET_FILTER_INTENSITY: 'SET_FILTER_INTENSITY',
  SET_ADJUST_ACTIVE: 'SET_ADJUST_ACTIVE',
  SET_ADJUST_DATA: 'SET_ADJUST_DATA',
  SET_ADJUST_DISABLED: 'SET_ADJUST_DISABLED',

  STOCK_SEARCH_LOADING: 'STOCK_SEARCH_LOADING',
  STOCK_SEARCH_SUBLOADING: 'STOCK_SEARCH_SUBLOADING',
  STOCK_SEARCH_SUCCESS: 'STOCK_SEARCH_SUCCESS',
  STOCK_SEARCH_ERROR: 'STOCK_SEARCH_ERROR',
  STOCK_SEARCH_NONE: 'STOCK_SEARCH_NONE',
  STOCK_SEARCH_END: 'STOCK_SEARCH_END',

	SEARCH_STOCK_VIDEO: 'SEARCH_STOCK_VIDEO',
	SEARCH_STOCK_IMAGE: 'SEARCH_STOCK_IMAGE',
	SEARCH_STOCK_MUSIC: 'SEARCH_STOCK_MUSIC',

  USER_PAYMENT_FREE: "USER_PAYMENT_FREE",
  USER_PAYMENT_BASIC: "USER_PAYMENT_BASIC",
  USER_PAYMENT_PLUS: "USER_PAYMENT_PLUS",
  USER_PAYMENT_BUSINESS: "USER_PAYMENT_BUSINESS",

  // resolution
  RESOLUTION_480P: '480',
  RESOLUTION_720P: '720',
  RESOLUTION_1080P: '1080',
}
